export const pathwaysData = [
    {
        id: 'p3',
        name: 'Professional Tutor Development Pack',
        tagline: 'View Program Details',
        description: 'This specially designed pathway equips educators with the tools to radically improve their learners\' skills over a six-month period.',
        fullDescription: [
            "This package is designed for vocational or workplace tutors (or others) seeking to integrate literacy and numeracy support into their current teaching. It equips tutors to work effectively with learners with lower literacy or numeracy skills, neurodiverse differences, or learning challenges.",
            "It is made up of 5 interconnected courses that run over a six-month period. Content addresses how and why some learners have learning needs, how to develop reading and writing skills within the context of your course, building numeracy skills, and supporting neurodiverse learners to gain agency and learning mastery.",
            "The pathway is designed around one weekly online workshop with optional support and resources supplied for each. This pathway equips educators to support and advance all learners, develop specific reading and writing skills, strengthen learner agency, and extend numeracy skills.",
            "Block One: Developing Learners’ Reading Skills (3 online sessions). This block teaches tutors how to not only address their learners’ reading difficulties but dramatically improve them. It addresses the challenge where learners can 'read' but struggle to 'read to learn', helping to increase resource effectiveness and learner outcomes.",
            "Block Two: Improving Writing as a Learning Tool (2 online sessions). Writing remains the main method of expressing ideas and completing coursework. This block shows tutors how to develop their learners’ writing skills and support them to integrate writing into daily practice as a tool for thinking and learning.",
            "Block Three: Teaching Learners How to Learn (3 online sessions). This course equips educators with the skills and strategies to empower their learners to take ownership of their goals, learning, and progress. It helps integrate learner agency into all teaching practice.",
            "Block Four: Supporting Neurodiverse Learners (3 online sessions). This block equips tutors with practical strategies to recognise and respond to the strengths and challenges of neurodiverse learners (such as those with dyslexia, dyscalculia, or ADHD), removing barriers to engagement and confidence.",
            "Block Five: Mastering Numeracy Instruction (3 online sessions). This block develops educator capability to teach essential numeracy skills. It helps tutors address the needs of learners lacking foundational math skills necessary for their course, life, or the workplace.",
            "All five blocks interweave and build on each other to equip educators with all the skills they need to radically develop the skills and confidence of their learners."
        ],
        valueSummary: {
            duration: "6 Months Duration",
            sessions: "14 Online Workshops",
            resources: "Full Resource Library Access",
            outcome: "Holistic Teaching Toolkit"
        },
        modules: [
            {
                title: "Developing Learners' Reading Skills",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Address and dramatically improve learners' reading difficulties",
                    "Transition learners from 'learning to read' to 'reading to learn'",
                    "Overcome challenges that reduce reading comprehension and retention",
                    "Implement immediate strategies to increase resource effectiveness"
                ]
            },
            {
                title: "Improving Writing as a Learning Tool",
                details: "2 online sessions supported with resources",
                workshops: [
                    "Develop learners' core writing skills for coursework and expression",
                    "Utilize writing as a primary tool for critical thinking and learning",
                    "Support learners to report events and structure ideas effectively",
                    "Integrate writing into daily practice to enhance overall learning"
                ]
            },
            {
                title: "Teaching Learners How to Learn",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Empower learners to take ownership of their goals and progress",
                    "Build learner confidence and independence through agency",
                    "Integrate powerful learner agency strategies into all teaching",
                    "Prepare learners for future success with self-management skills"
                ]
            },
            {
                title: "Supporting Neurodiverse Learners",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Recognise the strengths of learners with dyslexia, dyscalculia, or ADHD",
                    "Adapt teaching approaches to remove barriers to engagement",
                    "Help learners access content and demonstrate understanding in new ways",
                    "Apply practical strategies to improve participation, retention, and outcomes"
                ]
            },
            {
                title: "Mastering Numeracy Instruction",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Develop educator capability and confidence in teaching numeracy",
                    "Address the needs of learners lacking foundational math skills",
                    "Equip learners with numeracy for course, life, and workplace demands",
                    "Deliver enjoyable and beneficial numeracy content that engages tutors"
                ]
            }
        ],
        pricing: [
            {
                label: "Single Seat",
                amount: "NZ$3,000",
                per: "per person"
            },
            {
                label: "Team Cohort (Up to 10)",
                amount: "NZ$25,000",
                per: "Flat rate (Save $5,000)"
            }
        ]
    },
    {
        id: 'p2',
        name: 'Literacy, Numeracy and Neurodiversity Specialist ',
        tagline: 'View Program Details',
        description: 'Develop specialised skills for modern education, focusing on learner empowerment, supporting neurodiversity, and fostering workplace professionalism.',
        fullDescription: [
            "This pathway is designed for educators specifically seeking to become adult literacy and numeracy specialists. It benefits any organisation with educators working directly with adult learners who need learning support. Tutors will learn the skills and strategies to work successfully with diverse learners who have literacy and/or numeracy needs, specifically in the domains of dyslexia and dyscalculia.",
            "Tutors in the past who have completed this course have been literacy and numeracy tutors, workplace literacy tutors, tutors working one-to-one or in small groups, employment skills tutors, or educators running foundation-level courses. Even parents have done this course to be able to support their children. All are welcome!",
            "If you want to work successfully with learners to develop their reading, numeracy, writing, and self-learning skills, this is the pathway. This research-informed course includes: diagnostic assessment to identify specific needs; effective frameworks for reading, numeracy, and writing; sequential strategies and activities; resources and guides; and training on how to utilise AI to improve preparation and delivery.",
            "Block One: Developing Reading Skills (4-5 online workshops). This block focuses on the core components of reading, including phonological awareness, decoding, vocabulary, comprehension, and fluency. It is an ‘all you need’ package that addresses how to assess various needs, design effective long-term learning plans, and deliver high-quality instruction. It is suitable for educators working with non-readers, partial readers, and dyslexic adults.",
            "Block Two: Mastering Numeracy Instruction (5 online sessions). This block develops educator capability to build learners’ essential numeracy skills. It begins with counting and progresses toward decimals, percentages, and fractions. It provides the tools to support all learners, including neurodiverse dyscalculic learners. You do not have to be a math expert; this course provides the developmental pathway and strategies to dramatically improve learner performance.",
            "Block Three: Learning to Learn (4 online sessions). The objective of this block is to allow adult learners to begin to teach themselves. It equips educators with a framework to develop ‘learner identity,’ addressing confidence, esteem, and mindsets. It includes learning techniques to embed into practice, covering how to structure learning, set rewards, plan for setbacks, and use cognitive tools to solve unique problems.",
            "Block Four: Developing Writing Skills (3 online sessions). Many young adults struggle with writing, yet it is a key tool for thinking and learning. This block equips educators with the skills and tools to diagnose writing difficulties and to address spelling, vocabulary, structure, and composition. Participants will receive a framework to develop writing and a toolbox of strategies that can be applied in any environment.",
            "All four blocks interweave and build on each other to equip educators with the complete skillset needed to radically develop the capabilities and confidence of their learners."
        ],
        valueSummary: {
            duration: "6 Months Duration",
            sessions: "17 Online Workshops",
            resources: "Full Resource Library Access",
            outcome: "Expert Specialist Capability"
        },
        modules: [
            {
                title: "Developing Reading Skills",
                details: "4-5 online workshops supported with resources",
                workshops: [
                    "Master the core components: phonological awareness, decoding, vocabulary, comprehension, and fluency",
                    "Effectively diagnose needs and assess readers at any level",
                    "Design effective long-term learning plans and high-quality session plans",
                    "Implement specific strategies for non-readers, partial readers, and dyslexic adults"
                ]
            },
            {
                title: "Mastering Numeracy Instruction",
                details: "5 online sessions supported with resources",
                workshops: [
                    "Develop essential numeracy skills from counting to decimals, percentages, and fractions",
                    "Support all learners, including neurodiverse and dyscalculic learners",
                    "Master a developmental numeracy pathway without needing to be a math expert",
                    "Acquire strategies and tools to dramatically improve learner performance"
                ]
            },
            {
                title: "Learning to Learn",
                details: "4 online sessions supported with resources",
                workshops: [
                    "Develop 'learner identity' to boost confidence, esteem, and mindsets",
                    "Teach learners to structure learning, set rewards, and plan for setbacks",
                    "Use physiological, strategic, and cognitive tools to solve unique problems",
                    "Empower learners to teach themselves and take advantage of learning opportunities"
                ]
            },
            {
                title: "Developing Writing Skills",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Diagnose writing difficulties and address spelling, vocabulary, structure, and composition",
                    "Utilise a framework to develop writing for lower-level adult learners",
                    "Build a toolbox of strategies applicable in any environment",
                    "Use writing as a tool for thinking and learning"
                ]
            }
        ],
        pricing: [
            {
                label: "Single Seat",
                amount: "NZ$3,000",
                per: "per person"
            },
            {
                label: "Team Cohort (Up to 10)",
                amount: "NZ$25,000",
                per: "Flat rate (Save $5,000)"
            }
        ]
    },
    {
        id: 'p1',
        name: 'Numeracy Mastery Pathway',
        tagline: 'View Program Details',
        description: 'Develop the lifetime educational skill of teaching numeracy to adult learners. Designed for educators wanting to develop specialty in teaching adult numeracy.',
        fullDescription: [
            "Many adult educators feel anxious about teaching math. The Numeracy Mastery Pathway is designed to eliminate that anxiety and replace it with expert-level confidence.",
            "You do not need high-level math skills to succeed here. Instead, this pathway focuses on the pedagogy of numeracy-how to explain concepts so they stick. We break down the barriers that adult learners face, from 'math trauma' to specific learning difficulties like dyscalculia.",
            "This pathway covers the 'Big 3' foundational areas: Number Strategies, Proportional Reasoning, and Measurement/Statistics. By the end, you will have a toolbox of fun, contextualised activities that will revitalize your classroom and help your learners solve real-world problems."
        ],
        valueSummary: {
            duration: "6 Months Duration",
            sessions: "15 Online Workshops",
            resources: "Full Resource Library Access",
            outcome: "Numeracy Instruction Mastery"
        },
        modules: [
            {
                title: "Toolbox 1: Developing Number Skills",
                details: "3 online sessions supported with resources",
                workshops: [
                    "How adult difficulties with number skills interfere with course completion",
                    "Simple strategies to start delivering effective numeracy provision",
                    "Developing addition, subtraction, and multiplicative skills",
                    "Developing a toolbox of contextualised numeracy tasks",
                    "Introduction to a range of resources designed to develop learners’ skills"
                ]
            },
            {
                title: "Toolbox 2: Fractions, decimals, percentages and proportional reasoning",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Understanding decimals, fractions, and percentages",
                    "The importance of proportional reasoning for problem-solving",
                    "A model for developing adult learners’ numeracy skills",
                    "Using diagnostic assessment to target and develop key skills",
                    "Strategies for teaching fractions, decimals, and percentages"
                ]
            },
            {
                title: "Toolbox 3: Applying Numeracy: Problem-Solving",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Learn the secrets to effective problem-solving (and how to teach them)",
                    "Develop your learners’ problem-solving mind set",
                    "Apply numeracy skills to solve authentic problems",
                    "Develop a toolbox of fun learning activities that will revitalise your class",
                    "Develop and use numeracy to solve-problems"
                ]
            },
            {
                title: "Toolbox 4: Measurement & Statistics",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Effective strategies for developing measurement skills",
                    "Practical approaches to teaching statistical reasoning",
                    "Aligning learning activities with unit standard criteria",
                    "Resource introduction for measurement and statistics"
                ]
            },
            {
                title: "Toolbox 5: Supporting learners with numeracy learning difficulties (dyscalculia) ",
                details: "3 online sessions supported with resources",
                workshops: [
                    "Understand what dyscalculia is and how it is diagnosed",
                    "Recognise how dyscalculia interferes with life, study, and employment",
                    "Learn effective strategies that work with dyscalculic adults",
                    "Design and implement effective, targeted learning plans"
                ]
            }
        ],
        pricing: [
            {
                label: "Single Seat",
                amount: "NZ$3,000",
                per: "per person"
            },
            {
                label: "Team Cohort (Up to 10)",
                amount: "NZ$25,000",
                per: "Flat rate (Save $5,000)"
            }
        ]
    }
];